import { ApiProperty } from "@nestjs/swagger";
export class TransferIdRequest{
    @ApiProperty()
    packingStockTransferId:number;
    @ApiProperty()
    createdUser?:string;
    @ApiProperty()
    plantId?:number;
    @ApiProperty()
    versionFlag?:number;
}